function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M73.6969 88.54C73.6969 73.56 65.0169 64.6 46.3969 60.26L51.4369 30.16C57.4569 33.38 61.0969 39.12 61.5169 46.4H75.2369C74.6769 32.26 66.8369 21.76 53.5369 17.7L56.4769 0.199993H44.5769L41.9169 15.74C41.4969 15.6 40.6569 15.6 39.5369 15.6C19.3769 15.6 5.23688 27.78 5.23688 45C5.23688 58.44 14.8969 67.68 29.3169 70.62L32.6769 71.32L27.3569 102.68C18.9569 99.74 14.0569 93.02 14.0569 83.5H0.336875C0.896875 99.88 9.99688 110.94 25.2569 114.86L22.4569 131.8H34.3569L36.8769 116.4H38.8369C60.2569 116.4 73.6969 105.76 73.6969 88.54ZM31.9769 57.18C23.1569 55.36 18.9569 50.74 18.9569 43.46C18.9569 33.8 26.9369 27.5 38.8369 27.5H39.9569L34.9169 57.74L31.9769 57.18ZM59.9769 89.1C59.9769 98.48 51.9969 104.5 40.0969 104.5H38.9769L44.1569 73.84L44.9969 73.98C55.0769 76.08 59.9769 80.84 59.9769 89.1Z",
  fill: "url(#paint0_linear_8322_35775)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_8322_35775",
  x1: 7.20122,
  y1: -0.999999,
  x2: 69.524,
  y2: 123.557,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAFAFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D5D9DA",
  stopOpacity: 0
})));
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 132,
    viewBox: "0 0 76 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/DollarSign.7ccb004a.svg";
export { ForwardRef as ReactComponent };